import React from 'react';
import classnames from 'classnames';
import renderHTML from 'react-render-html';
import CheckboxInput from './CheckboxInput';
import HiddenInput from './HiddenInput';
import Tooltip from './Tooltip';

const parseLabel = (text) => {
  if (!text) {
    return null;
  }
  return renderHTML(text);
};

const CheckboxHidden = (props) => {
  const {
    drawHidden,
    name,
    groupName,
    defaultValue,
  } = props;

  if (drawHidden) {
    return (
      <HiddenInput name={name} groupName={groupName} value={defaultValue} />
    );
  }
  return null;
};

const CheckboxComponent = props => {
  const {
    label,
    inputClassName,
    inputId,
    name,
    tooltip,
  } = props;

  return (
    <div className="form-check">
      <CheckboxHidden {...props} />
      <CheckboxInput
        {...props}
        inputClassName={classnames('form-check-input', inputClassName)} />
      <label className="form-check-label" htmlFor={inputId}>
        {parseLabel(label)} <Tooltip id={`tooltip-${name}`} title={tooltip} />
      </label>
    </div>
  );
};

CheckboxComponent.defaultProps = {
  label: '',
  value: '1',
  defaultValue: '0',
  drawHidden: true,
};

export default CheckboxComponent;
